module.exports = __webpack_public_path__ + "img/security.06712d41.svg";